import { inject } from "inversify";
import * as ILicenseRepository from "@domain/repositories/ILicenseRepository";
import { TYPES } from "@utils/inversifyJS/types";

export class SaveLicenseService {
  constructor(
    @inject(TYPES.ILicenseRepository)
    private readonly licenseRepository: ILicenseRepository.ILicenseRepository
  ) {}

  public async execute(licenseKey: string): Promise<void> {
    await this.licenseRepository.saveLicense(licenseKey);
  }
}
